import React from 'react'
import { injectIntl } from 'react-intl'
import { menuItems } from 'services/menu'
import { withLocation } from 'redux/enhancers'
import { Helmet } from 'react-helmet'
import ShowForScreenWidth from 'components/ShowForScreenWidth'
import Notifications from './Notifications'
import MobileMenu from './MobileMenu'
import style from './style.module.scss'

const APP_NAME = 'Super Ego Business';

const Header = ({ location, intl: { formatMessage } }) => {
  let title = ''

  menuItems.forEach(menuItem => {
    if (menuItem.url === location.pathname) {
      // eslint-disable-next-line prefer-destructuring
      title = menuItem.title
    }
  })

  if (location.pathname === '/') {
    title = 'title.main'
  }

  if (title === '') {
    return null
  }

  const translatedTitle = formatMessage({ id: title })

  return (
    <>
      <Helmet title={`${translatedTitle} | ${APP_NAME}`} />
      <div className={style.header}>
        <h1>{translatedTitle}</h1>
        <Notifications />
        <ShowForScreenWidth max={900}>
          <MobileMenu />
        </ShowForScreenWidth>
      </div>
    </>
  )
}

export default injectIntl(withLocation(Header))
